import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { SeAnalyticsService } from 'se-analytics';
import { trackReportPageView } from '../analytics/view-report-analytics';
import { OverviewChartReportKey } from '../models/overview-chart';

@Injectable({
  providedIn: 'root',
})
export class ViewReportAnalyticsGuard implements CanActivate {
  constructor(private readonly seAnalytics: SeAnalyticsService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const viewReportKey = route.data['viewReportKey'] as OverviewChartReportKey | undefined;

    if (viewReportKey) {
      trackReportPageView(this.seAnalytics, viewReportKey);
    }

    return true;
  }
}
